import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles';
import { userRegister } from '@bd/bdcore-data/build/User/actions';
import withData from '@bd/bdcore-data';
import { colors } from '../../styles';

const styles = css`
  .form-heading {
    font-weight:700;
    color:${colors.color2};
    text-transform: uppercase;
  }
  .ClientRegister_formSection {
    width:100%;
    padding:0 20px 40px 20px;
  }
`;

class ClientRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      communityName: 'undefined',
      showSubmitButton: true,
    };
  }

  handleInput = event => {
    const key = event.target.name;
    const value = event.target.value;
    let selectedCommunity = [];

    if (key === 'hoaCommunity') {
      selectedCommunity = this.props.communities.filter(comm => {
        return comm._id === value;
      });
      if (selectedCommunity.length) {
        this.setState({
          communityName: selectedCommunity[0].name,
        });
      }
    }

    this.setState({
      [key]: value,
    });
  }

  render() {
    /*
    * Ticket 24483. Block One asked to disable two specific portals. Builder Cloud does not have a
    * way to disable a portal in the UI. A "disabled": true flag was manually added to the specific
    * portals in the database. However withData does not return that field on the portal object
    * when getting the hoaPortals data set. It is returned when retrieving an individual portal
    * from withData. That flag allows to inform the end user the portal has been disabled upon.
    * Since it is not on the portal objects when retrieving the entire array, the following
    * disabledPortals filter was added here to only remove the portals from the new registration
    * select. This is not ideal and bdcore should be updated to return the disabled flag.
    */
    /* const disabledPortals = ['Abbey Place', 'Timberline', 'Asheville', 'Meadow Ridge',
    'Highland Meadows', 'Highland Farms', 'Savannah Estates', 'Azalea Park', 'Timberland Hills']; */
    const { communities, hoaPortals, dispatch } = this.props;
    const disabledPortals = communities.filter(c => _.get(c, 'disable_hoa') === true).map(com => com.name);
    const portalCommunities = _.map(hoaPortals, 'community_id').map(id => communities.find(c => c._id === id));
    const uniquePortalCommunities = [...new Set(portalCommunities)]
      .filter(c => c && !disabledPortals.includes(c.name));
    const serviceName = `Community: ${this.state.communityName}`;
    return (
      <div className={styles}>
        <form
          onSubmit={event => {
            event.preventDefault();
            this.setState({ showSubmitButton: false });
            dispatch(userRegister({ ...this.state, serviceName }));
          }}
        >
          <div className="ClientRegister">
            <div className="ClientRegister_formSection">
              <h4 className="form-heading">Register</h4>
              <div className="form-group">
                <label htmlFor="hoaCommunity">Your Community</label>
                <select className="form-control" name="hoaCommunity" onChange={this.handleInput}>
                  {
                    _.orderBy(uniquePortalCommunities, 'name').map(community => (
                      <option key={community._id} value={community._id}>{community.name}</option>
                    ))
                  }
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="registerEmail">Email</label>
                <input className="form-control" type="text" name="email" id="registerEmail" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <input className="form-control" type="text" name="firstName" id="firstName" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>
                <input className="form-control" type="text" name="lastName" id="lastName" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="registerPassword">Password</label>
                <input className="form-control" type="password" name="password" id="registerPassword" onChange={this.handleInput} required />
              </div>
              <div className="form-group">
                <label htmlFor="password">Confirm Password</label>
                <input className="form-control" type="password" name="confirmPassword" id="confirmPassword" onChange={this.handleInput} required />
              </div>
              {this.state.showSubmitButton && <button className="btn">Register</button>}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

ClientRegister.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  hoaPortals: PropTypes.arrayOf(PropTypes.object).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withData({
  hoaPortals: true,
  communities: 'all',
})(ClientRegister);



// WEBPACK FOOTER //
// ./src/pages/HoaPortal/HOAClientRegister.js